<template>
  <span>
    {{ formatCurrency(price, currency) }} {{ convertChargingCycle(chargingCycle) }}
    <span v-if="chargingCycle" v-html="chargingCycleSubscription"></span>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import FormatCurrencyMixin from '@/mixins/formatCurrency';
import { convertChargingCycle } from '@/utils/price';

export default {
  name: 'CitaPrice',

  mixins: [FormatCurrencyMixin],

  props: {
    footnotes: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('cita', ['price', 'currency', 'chargingCycle']),

    chargingCycleSubscription() {
      const text = this.$t('cita.chargingCycleSubscription') + '<sup>subscriptionFootnote</sup>';
      return this.footnotes.parse(text);
    },
  },

  methods: {
    convertChargingCycle,
  },
};
</script>
